define("shared/components/shared/mavely/links/folders-tab", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.MavelyLinksFoldersTabComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cLB--linkFolders"
    data-qa-id="qa--mavely_folder_section"
    data-test-id="mavely-folders-tab"
    {{perfect-scroll}}
  >
    {{#unless (user-agent "device.isMobile")}}
      <Shared::Ui::Button
        @additional="block"
        @class={{concat-classes "cLB--linkFolders__item u--m__0 u--text--bold" (unless @selectedFolderId "is--selected")}}
        @onClick={{fn @selectFolder undefined}}
        @variant="unstyled"
        data-qa-id="qa--mavely_folder_all_links"
        data-test-id="mavely-folders-all-links-btn"
      >
        <span>
          {{t "mavely.links_modal.folders.all_links"}}
        </span>
        <span data-test-id="mavely-folders-all-links-count">
          {{@totalLinks}}
        </span>
      </Shared::Ui::Button>
    {{/unless}}
    {{#each @folders as |folder|}}
      <Shared::Mavely::Links::Folder
        @folder={{folder}}
        @isSelected={{eq folder.id @selectedFolderId}}
        @selectFolder={{fn @selectFolder folder.id}}
      />
    {{/each}}
  
    {{#if @canLoadMore}}
      <div class="u--m">
        <Shared::Ui::Button
          @additional="block"
          @class="cLB--linksModal__footer u--text--hl"
          @promise={{@loadMore}}
          @text={{t "shared_phrases.load_more"}}
          @variant="outline"
          data-qa-id="qa--mavely_load_more_folders_btn"
          data-test-id="load-more-folders-button"
        />
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "AGUvFQAh",
    "block": "[[[11,0],[24,0,\"cLB--linkFolders\"],[24,\"data-qa-id\",\"qa--mavely_folder_section\"],[24,\"data-test-id\",\"mavely-folders-tab\"],[4,[38,0],null,null],[12],[1,\"\\n\"],[41,[51,[28,[37,2],[\"device.isMobile\"],null]],[[[1,\"    \"],[8,[39,3],[[24,\"data-qa-id\",\"qa--mavely_folder_all_links\"],[24,\"data-test-id\",\"mavely-folders-all-links-btn\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",[28,[37,4],[\"cLB--linkFolders__item u--m__0 u--text--bold\",[52,[51,[30,1]],\"is--selected\"]],null],[28,[37,5],[[30,2],[27]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,6],[\"mavely.links_modal.folders.all_links\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"mavely-folders-all-links-count\"],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[42,[28,[37,8],[[28,[37,8],[[30,4]],null]],null],null,[[[1,\"    \"],[8,[39,9],null,[[\"@folder\",\"@isSelected\",\"@selectFolder\"],[[30,5],[28,[37,10],[[30,5,[\"id\"]],[30,1]],null],[28,[37,5],[[30,2],[30,5,[\"id\"]]],null]]],null],[1,\"\\n\"]],[5]],null],[1,\"\\n\"],[41,[30,6],[[[1,\"    \"],[10,0],[14,0,\"u--m\"],[12],[1,\"\\n      \"],[8,[39,3],[[24,\"data-qa-id\",\"qa--mavely_load_more_folders_btn\"],[24,\"data-test-id\",\"load-more-folders-button\"]],[[\"@additional\",\"@class\",\"@promise\",\"@text\",\"@variant\"],[\"block\",\"cLB--linksModal__footer u--text--hl\",[30,7],[28,[37,6],[\"shared_phrases.load_more\"],null],\"outline\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@selectedFolderId\",\"@selectFolder\",\"@totalLinks\",\"@folders\",\"folder\",\"@canLoadMore\",\"@loadMore\"],false,[\"perfect-scroll\",\"unless\",\"user-agent\",\"shared/ui/button\",\"concat-classes\",\"fn\",\"t\",\"each\",\"-track-array\",\"shared/mavely/links/folder\",\"eq\",\"if\"]]",
    "moduleName": "shared/components/shared/mavely/links/folders-tab.hbs",
    "isStrictMode": false
  });
  const MavelyLinksFoldersTabComponent = _exports.MavelyLinksFoldersTabComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLinksFoldersTabComponent);
});